'use strict'

export default class Footer
{
  constructor( )
  {
    this.$elem = $('.Footer')

    if( this.$elem.length > 0 ){
      let self = this

      this.$menu = this.$elem.find('.Footer__menu')
      this.$social = this.$elem.find('.Footer__social')
      this.menuCreated = false
      this.$scrollTop = this.$elem.find('.Footer__scrollTop')

      $(document).ready(function(){
        self._controllerMenu()
        self._controllerScrollTop()

        self.$scrollTop.on('click', function(){
          let $body = $("html, body")
          $body.stop().animate({scrollTop:0}, '500', 'swing', function() {})
        })

        if( $(document).outerHeight() < window.innerHeight * 2 ){
          self.$scrollTop.hide()
        }  
      })

      $(window).resize( ()=> {

      })

      $(window).on("orientationchange", ()=> {

      })

      $( window ).scroll( ()=> {
        self._controllerScrollTop()
      })
    }
  }

  _controllerMenu()
  {
    let self = this
    if( !self.menuCreated ){
      self.menuCreated = true

      $.each( self.$menu.children(), function( i,val ){
        $(this).addClass('col')
        if( i == 0 ){
          $('<i class="fa fa-phone" aria-hidden="true"></i>').insertBefore( $(this).children() )
        }

        if( i == 2 || i == 3 ){
          $(this).addClass('col').children().attr('target','_blank')
        }
      })

      let $social = $('.Footer__social')
      $.each( $social.children(), function( i,val ){
        $(this).addClass('col')
        $(this).insertAfter(self.$menu.children().eq(1));
      })
      
      $social.remove()
    }
  }

  _controllerScrollTop()
  {
    if( window.scrollY + window.innerHeight >= this.$elem.offset().top ){
      if( !this.$scrollTop.hasClass('active') ){
          this.$scrollTop.addClass('active fadeInUp')
      }
    }
    else{
      if( this.$scrollTop.hasClass('active') ){
          this.$scrollTop.removeClass('active fadeInUp')
      }
    }
  }
}
